import { useModal } from "../../../utils/ModalContext";
import { FiX } from "react-icons/fi";
import NoWalletModalStyleWrapper from "./NoWalletModal.style";
import hoverShape from "../../../assets/images/icon/hov_shape_L.svg";
import hoverShapeSmall from "../../../assets/images/icon/hov_shape_s.svg";
import data from "../../../assets/data/socialShare";
import oopsImg from "../../../assets/images/octopuses/Oops.png";
import Button from "../../button";

const NoWalletModal = () => {

  const { noWalletModalHandle } = useModal();
  console.log('rendering no wallet modal')

  return (
    <>
      <NoWalletModalStyleWrapper className="modal_overlay">
        <div className="mint_modal_box">
          <div className="mint_modal_content">
            <div className="modal_header">
              <h2>Oops!!!!...</h2>
              <p>You dont have any wallet isInstalled</p>
              <button onClick={(e) => noWalletModalHandle(e)}>
                <FiX />
              </button>
            </div>
            <div className="modal_body text-center">
              <div className="modal-img">
                <img src={oopsImg} alt="ALPHA OCTOPUS no wallet" style={{height:200}}/>
              </div>
            </div>
            <div className="modal-button">
              <Button lg variant="mint" onClick={(e) => {window.open("https://metamask.io", "_blank"); noWalletModalHandle(e)}} >
              Download Metamask
              </Button>
            </div>
            <div className="modal_bottom_shape_wrap">
              <span className="modal_bottom_shape shape_left">
                <img src={hoverShape} alt="bithu nft hover shape" />
              </span>
              <span className="modal_bottom_shape shape_right">
                <img src={hoverShape} alt="bithu nft hover shape" />
              </span>
            </div>
          </div>
        </div>
      </NoWalletModalStyleWrapper>
    </>
  );
};

export default NoWalletModal;
